import { Typography } from "@mui/material";
import isNil from "lodash/isNil";
import type { FC } from "react";
import type { Currency } from "../../data/BaseEntity";

interface Props {
  label: string;
  value: number | null;
  currency: Currency;
}

export const moneyText = (value: number | null, currency: Currency, label: string): string =>
  isNil(value) ? `${label}: n.d.` : `${label}: ${roundToCents(value)} ${currency}`;

const roundToCents = (value: number): number => Number(value.toFixed(2)) || 0;

const MoneyValue: FC<Props> = ({ label, value, currency }) => {
  const text = moneyText(value, currency, label);
  return (
    <Typography variant="h6" aria-label={label}>
      {text}
    </Typography>
  );
};

export default MoneyValue;
